import { useState } from 'react';
import { ModalReportProblem } from '../modals/reportProblemModal';
import { ApplicationName } from "../../configs";
import { Link } from 'react-router-dom';
import packageJson from '../../../package.json';

export function Footer(): JSX.Element {
  const [show, setShow] = useState<boolean>(false);

  return (
    <>
      <footer className="footer ">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col">
              <p className='text-center mb-0'>
                <small>
                  &#169;  {ApplicationName}
                  <Link to="/changelog" style={{fontSize: "10px", fontWeight: "500", color: "var(--site-purple)", marginLeft: "3px"}}>
                  {packageJson.version}
                  </Link>

                </small>
              </p>
            </div>
            <div className="ml-auto  width-fit-content mr-3">
              {/* <Link to="/changelog" style={{fontSize: "12px", color: "var(--site-purple)"}}>
                Changelog
              </Link> */}
            </div>
          </div>


        </div>
      </footer>
      <ModalReportProblem
        show={show}
        handleShow={setShow}
      />
    </>
  )
}
